import React from "react";
import style from "../../Styles/Components/ProduceHistory.module.css";

import Title from "../Section/Title";

const ProduceHistory = ({codeProduct, product, ELocale}) => (
  <div className={style.container}>
    <Title title={ELocale === 'kr ' ? "제조정보" : ELocale === 'en' ? 'Product Info' : ELocale === 'cn' ? '制造信息' : null} />
    <div className={style.content}>
      <div className={style.description}>
        <span className={style.orangeDot} />
        {ELocale === 'kr' ?
        <span className={style.descriptionText}>
          <span className={style.textBold}>{product[ELocale].name}</span>이{" "}
          <span className={style.textBold}>{product[ELocale + 'CompanyName']}</span>에서{" "}
          <span className={style.textBold}>제조</span>되었습니다.
        </span> : null}
        {ELocale === 'en' ?
        <span className={style.descriptionText}>
          <span className={style.textBold}>{product[ELocale].name}</span>{" "}is
          <span className={style.textBold}> manufactured </span>{" "}by{" "}
          <span className={style.textBold}>{product[ELocale + 'CompanyName']}.</span>
        </span> : null}
        {ELocale === 'cn' ?
          <span className={style.descriptionText}>
          <span className={style.textBold}>{product[ELocale].name}</span>{" "}
          <span className={style.textBold}>的制造商为</span>{" "}
            <span className={style.textBold}>{product[ELocale + 'CompanyName']}.</span>
        </span> : null}
      </div>
      {codeProduct.manufactureUrl ? <div className={style.map} style={{ backgroundImage: "url('" + codeProduct.manufactureUrl + "')"}}/> : null}
    </div>
  </div>
);

export default ProduceHistory;
